import { render, staticRenderFns } from "./EmployeeSkills.vue?vue&type=template&id=6b41265c&scoped=true"
import script from "./EmployeeSkills.vue?vue&type=script&lang=js"
export * from "./EmployeeSkills.vue?vue&type=script&lang=js"
import style0 from "./EmployeeSkills.vue?vue&type=style&index=0&id=6b41265c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b41265c",
  null
  
)

export default component.exports